;(function () {
  let buildABoxInstance = null

  function initBuildABox() {
    class BuildABox {
      constructor() {
        this.maxItems = 8
        this.totalItems = 0
        this.totalPrice = 0
        this.selectedVariantId = null
        this.currentStep = 'options'

        this.progressSteps = document.querySelectorAll('.progress-step')
        this.boxOptions = document.getElementById('box-options')
        this.boxSizeSelection = document.getElementById('box-size-selection')
        this.customBoxSection = document.getElementById('custom-box')
        this.preSelectedSection = document.getElementById('pre-selected')
        this.productCards = document.querySelectorAll('.product-card')
        this.preSelectedCards = document.querySelectorAll('.pre-selected-card')
        this.remainingItemsElement = document.getElementById('remainingItems')
        this.maxItemsElement = document.getElementById('maxItems')
        this.boxSizeDisplayElement = document.getElementById('boxSizeDisplay')
        this.totalPriceElement = document.getElementById('totalPrice')
        this.addToCartBtn = document.getElementById('addToCartBtn')
        this.boxContentsElement = document.getElementById('boxContents')
        this.progressBar = document.getElementById('itemsProgressBar')

        this.boxProductData = JSON.parse(
          document.getElementById('boxProductData')?.textContent || '{}'
        )

        this.boundEventListeners = new Map()
        this.initEventListeners()
        this.initPreSelectedEventListeners()
        this.updateSummary()
        this.updateProgressSteps()
        this.initializeCollections()
      }

      showSection(section, step) {
        this.boxOptions.classList.add('hidden')
        this.boxSizeSelection.classList.add('hidden')
        this.customBoxSection.classList.add('hidden')
        this.preSelectedSection.classList.add('hidden')
        section.classList.remove('hidden')
        this.currentStep = step
        this.updateProgressSteps()
      }

      updateProgressSteps() {
        this.progressSteps.forEach((step) => {
          if (step.dataset.step === this.currentStep) {
            step.classList.add('active')
          } else {
            step.classList.remove('active')
          }
        })
      }

      updateSummary() {
        console.log('totalItems', this.totalItems)
        console.log('maxItems', this.maxItems)

        if (this.remainingItemsElement) {
          this.remainingItemsElement.textContent = this.maxItems - this.totalItems
        }
        if (this.totalPriceElement) {
          this.totalPriceElement.textContent = `$${this.totalPrice.toFixed(2)}`
        }
        if (this.addToCartBtn) {
          this.addToCartBtn.disabled = this.totalItems < this.maxItems
        }
        if (this.progressBar) {
          const progressPercentage = (this.totalItems / this.maxItems) * 100
          this.progressBar.style.width = `${progressPercentage}%`
        }
      }

      updateBoxContents() {
        if (this.boxContentsElement) {
          this.boxContentsElement.innerHTML = ''
          this.productCards.forEach((card) => {
            const quantity = parseInt(card.querySelector('.quantity').value)
            if (quantity > 0) {
              const title = card.querySelector('.product-title').textContent
              const boxItem = document.createElement('div')
              boxItem.classList.add('box-item')
              boxItem.innerHTML = `
                <span>${title}</span>
                <span>x${quantity}</span>
              `
              this.boxContentsElement.appendChild(boxItem)
            }
          })
        }
      }

      resetBoxBuilder() {
        this.totalItems = 0
        this.totalPrice = 0
        this.productCards.forEach((card) => {
          const quantityInput = card.querySelector('.quantity')
          if (quantityInput) {
            quantityInput.value = '0'
          }
        })
        this.updateSummary()
        this.updateBoxContents()
      }

      initEventListeners() {
        const customBoxElement = document.querySelector('.custom-box')
        if (customBoxElement) {
          this.addBoundEventListener(customBoxElement, 'click', (e) => {
            e.preventDefault()
            this.showSection(this.boxSizeSelection, 'box-size')
          })
        }

        const preSelectedElement = document.querySelector('.pre-selected')
        if (preSelectedElement) {
          this.addBoundEventListener(preSelectedElement, 'click', (e) => {
            e.preventDefault()
            this.showSection(this.preSelectedSection, 'build-box')
          })
        }

        document.querySelectorAll('.box-size-option').forEach((option) => {
          this.addBoundEventListener(option, 'click', () => {
            this.selectedVariantId = option.dataset.variantId
            this.maxItems = parseInt(option.dataset.maxItems)
            const boxSize = option.dataset.size
            if (this.maxItemsElement) {
              this.maxItemsElement.textContent = this.maxItems
            }
            if (this.boxSizeDisplayElement) {
              this.boxSizeDisplayElement.textContent = boxSize
            }
            this.showSection(this.customBoxSection, 'build-box')
            this.resetBoxBuilder()
          })
        })

        this.progressSteps.forEach((step) => {
          this.addBoundEventListener(step, 'click', () => {
            const clickedStep = step.dataset.step
            if (clickedStep === 'options') {
              this.showSection(this.boxOptions, 'options')
            } else if (clickedStep === 'box-size' && this.currentStep !== 'options') {
              this.showSection(this.boxSizeSelection, 'box-size')
            }
          })
        })

        this.productCards.forEach((card) => {
          const minusBtn = card.querySelector('.minus')
          const plusBtn = card.querySelector('.plus')
          const quantityInput = card.querySelector('.quantity')
          const productPrice = parseFloat(card.dataset.productPrice)

          if (minusBtn) {
            this.addBoundEventListener(minusBtn, 'click', () => {
              let quantity = parseInt(quantityInput.value)
              if (quantity > 0) {
                quantity--
                this.totalItems--
                this.totalPrice -= productPrice
                quantityInput.value = quantity
                this.updateSummary()
                this.updateBoxContents()
              }
            })
          }

          if (plusBtn) {
            this.addBoundEventListener(plusBtn, 'click', () => {
              let quantity = parseInt(quantityInput.value)
              if (this.totalItems < this.maxItems) {
                quantity++
                this.totalItems++
                this.totalPrice += productPrice
                quantityInput.value = quantity
                this.updateSummary()
                this.updateBoxContents()
              }
            })
          }
        })

        if (this.addToCartBtn) {
          this.addBoundEventListener(this.addToCartBtn, 'click', this.handleAddToCart.bind(this))
        }
      }

      initPreSelectedEventListeners() {
        this.preSelectedCards.forEach((card) => {
          const addButton = card.querySelector('.add-pre-selected-btn')
          if (addButton) {
            this.addBoundEventListener(addButton, 'click', () =>
              this.handleAddPreSelectedToCart(card)
            )
          }
        })
      }

      addBoundEventListener(element, event, handler) {
        if (!element) {
          console.warn(`Element not found for event: ${event}`)
          return
        }

        const boundHandler = handler.bind(this)
        element.addEventListener(event, boundHandler)

        if (!this.boundEventListeners.has(element)) {
          this.boundEventListeners.set(element, new Map())
        }
        this.boundEventListeners.get(element).set(event, boundHandler)
      }

      getSelectedPurchaseOption(card) {
        const purchaseOptionSelector = card.querySelector('select[name="purchase_option"]')
        console.log('Purchase option selector:', purchaseOptionSelector)

        if (purchaseOptionSelector) {
          const selectedOption = purchaseOptionSelector.value
          console.log('Selected purchase option:', selectedOption)

          if (selectedOption === 'one-time') {
            return { type: 'one-time' }
          } else if (selectedOption.startsWith('selling_plan_')) {
            return {
              type: 'subscription',
              sellingPlanId: selectedOption.replace('selling_plan_', ''),
            }
          }
        }

        return null
      }

      handleAddToCart(e) {
        e.preventDefault()

        const items = []
        let hasItems = false
        let boxContents = []

        this.productCards.forEach((card) => {
          const quantityInput = card.querySelector('.quantity')
          if (quantityInput) {
            const quantity = parseInt(quantityInput.value)
            const productId = card.dataset.productId
            const productTitle = card.querySelector('.product-title')?.textContent

            if (quantity > 0) {
              boxContents.push(`${productTitle} x${quantity}`)
              const item = {
                id: productId,
                quantity: quantity,
                properties: {
                  '_In Custom Box': 'true',
                },
              }

              items.push(item)
              hasItems = true
            }
          }
        })

        if (hasItems && this.selectedVariantId) {
          const boxItem = {
            id: this.selectedVariantId,
            quantity: 1,
            properties: {
              '_Is Custom Box': 'true',
              '_Box Contents': boxContents.join(', '),
              '_Box Size': this.boxProductData.variants.find(
                (v) => v.id.toString() === this.selectedVariantId
              )?.title,
            },
          }

          items.unshift(boxItem)

          this.addItemsToCart(items)
        } else if (!hasItems) {
          alert('Please add at least one item to your box before adding to cart.')
        } else {
          alert('Please select a box size before adding to cart.')
        }
      }

      handleAddPreSelectedToCart(card) {
        const productId = card.dataset.productId
        const variantId = card.dataset.variantId

        const item = {
          id: variantId || productId,
          quantity: 1,
        }

        const purchaseOption = this.getSelectedPurchaseOption(card)

        if (!purchaseOption) {
          alert('Please select a purchase option for this product.')
          return
        }

        if (purchaseOption.type === 'subscription') {
          item.selling_plan = purchaseOption.sellingPlanId
        }

        try {
          const contents = JSON.parse(card.dataset.boxContents || '[]')

          if (Array.isArray(contents)) {
            const properties = {}

            contents.forEach((content, index) => {
              if (typeof content === 'string' && content.trim() !== '') {
                properties[`Contents ${index + 1}`] = content.trim()
              }
            })

            if (Object.keys(properties).length > 0) {
              item.properties = properties
            }
          }
        } catch (error) {
          console.error('Could not read box contents:', error)
          alert('Could not load the box contents. Please reload and try again.')
          return
        }

        console.log('Adding item to cart:', item)
        this.addItemsToCart([item])
      }


      addItemsToCart(items) {
        console.log('Items to be added to cart:', JSON.stringify(items, null, 2))

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ items: items }),
        })
          .then((response) => {
            if (!response.ok) {
              return response.json().then((errorData) => {
                console.error('Error response:', errorData)
                throw new Error(
                  `HTTP error! status: ${response.status}, message: ${JSON.stringify(errorData)}`
                )
              })
            }
            return response.json()
          })
          .then((data) => {
            console.log('Cart add response:', data)
            if (data.items && data.items.length > 0) {
              document.documentElement.dispatchEvent(
                new CustomEvent('booster:cart:update', {
                  bubbles: true,
                })
              )
              BoosterTheme.cart.open()
            } else {
              throw new Error('No items were added to the cart')
            }
          })
          .catch((error) => {
            console.error('Error:', error)
            console.error('Request body:', JSON.stringify({ items: items }))
            alert(
              `There was an error adding items to the cart: ${error.message}. Please check the console for more details.`
            )
          })

        setTimeout(() => {
          this.resetBoxBuilder()
        }, 100)
      }

      initializeCollections() {
        const collectionTabs = document.querySelectorAll('.collection-tab')
        const productGrids = document.querySelectorAll('.product-grid')

        function switchCollection(collectionHandle) {
          console.log('Switching to collection:', collectionHandle)

          productGrids.forEach((grid) => {
            grid.classList.add('hidden')
            grid.classList.remove('active')
          })

          const selectedGrid = document.querySelector(
            `.product-grid[data-collection="${collectionHandle}"]`
          )
          if (selectedGrid) {
            selectedGrid.classList.add('active')
            selectedGrid.classList.remove('hidden')
          } else {
            console.error('No product grid found for collection:', collectionHandle)
          }

          collectionTabs.forEach((tab) => {
            if (tab.dataset.collectionHandle === collectionHandle) {
              tab.classList.add('active')
            } else {
              tab.classList.remove('active')
            }
          })
        }

        collectionTabs.forEach((tab) => {
          tab.addEventListener('click', () => {
            const collectionHandle = tab.dataset.collectionHandle
            switchCollection(collectionHandle)
          })
        })

        const firstCollectionTab = document.querySelector('.collection-tab')
        if (firstCollectionTab) {
          const firstCollectionHandle = firstCollectionTab.dataset.collectionHandle
          switchCollection(firstCollectionHandle)
        }
      }

      cleanup() {
        this.boundEventListeners.forEach((events, element) => {
          events.forEach((handler, event) => {
            element.removeEventListener(event, handler)
          })
        })
        this.boundEventListeners.clear()

        this.maxItems = 8
        this.totalItems = 0
        this.totalPrice = 0
        this.selectedVariantId = null
        this.currentStep = 'options'

        if (this.boxContentsElement) {
          this.boxContentsElement.innerHTML = ''
        }

        this.resetBoxBuilder()
        this.updateProgressSteps()

        this.progressSteps = null
        this.boxOptions = null
        this.boxSizeSelection = null
        this.customBoxSection = null
        this.preSelectedSection = null
        this.productCards = null
        this.preSelectedCards = null
        this.remainingItemsElement = null
        this.maxItemsElement = null
        this.boxSizeDisplayElement = null
        this.totalPriceElement = null
        this.addToCartBtn = null
        this.boxContentsElement = null
        this.progressBar = null

        console.log('Build-a-Box instance cleaned up')
      }
    }

    if (buildABoxInstance) {
      buildABoxInstance.cleanup()
    }
    buildABoxInstance = new BuildABox()
  }

  document.addEventListener('DOMContentLoaded', initBuildABox)

  document.addEventListener('shopify:section:load', (event) => {
    initBuildABox()
  })

  document.addEventListener('shopify:section:unload', (event) => {
    if (buildABoxInstance) {
      buildABoxInstance.cleanup()
      buildABoxInstance = null
    }
  })

  window.initBuildABox = initBuildABox
})()
